// extracted by mini-css-extract-plugin
module.exports = {"details":"Login_details__CFDUp"};